<template>
	<div class="pl-box">
		<!-- 评论列表 -->
		<div class="pl-list" ref="list" @scroll="handleListScroll">
			<div class="pl-item" v-for="(c, ci) in list" :key="c.id">
				<img v-if="c.avatar" class="pl-avatar" :src="c.avatar" />
				<div v-else class="pl-avatar pl-avatar--empty"></div>
				<div class="pl-main">
					<div class="pl-name">{{ c.nickName }}</div>
					<div class="pl-content">{{ c.content }}</div>
					<div class="pl-meta">
						<span class="pl-time">{{ formatTime(c.createTime) }}</span>
						<span class="pl-reply-btn" @click="startReply(c)">{{ $t('all.huifu') }}</span>
						<span class="pl-del" v-if="isMine(c)" @click="delComment(c, ci)">{{ $t('all.shanchu') }}</span>
					</div>
					<!-- 子回复列表（预载部分，更多走接口加载） -->
					<div class="pl-childs" v-if="c.childs.length">
						<div class="pl-child" v-for="(r, ri) in c.childs" :key="r.id">
							<img v-if="r.avatar" class="pl-child-avatar" :src="r.avatar" />
							<div v-else class="pl-child-avatar pl-avatar--empty"></div>
							<div class="pl-main">
								<div class="pl-name">{{ r.nickName }}</div>
								<div class="pl-content">{{ r.content }}</div>
								<div class="pl-meta">
									<span class="pl-time">{{ formatTime(r.createTime) }}</span>
									<span class="pl-reply-btn" @click="startReply(c, r)">{{ $t('all.huifu') }}</span>
									<span class="pl-del" v-if="isMine(r)" @click="delReply(c, r, ri)">{{ $t('all.shanchu') }}</span>
								</div>
							</div>
						</div>
						<div class="pl-child-more" v-if="c.childHasMore" @click="loadChilds(c)">{{ childMoreText(c) }}</div>
					</div>
					<div class="pl-expand" v-if="c.replyNumber > 0 && c.childs.length === 0" @click="loadChilds(c)">{{ $t('all.chakanhuifu') }} ({{ c.replyNumber }})</div>
				</div>
			</div>
			<!-- 空状态：加载完成且无评论时显示 -->
			<kong v-if="loaded && !loading && list.length === 0"></kong>
			<div class="pl-tip" v-if="loading">{{ $t('all.jiazaizhong') }}</div>
			<div class="pl-tip" v-if="!hasMore && list.length > 0">{{ $t('all.meiyougengduo') }}</div>
		</div>
		<!-- 回复目标提示 -->
		<div class="pl-reply-chip" v-if="replyTarget">
			<span class="pl-reply-chip-text">{{ replyChipText }}</span>
			<svg class="pl-reply-chip-close" viewBox="0 0 24 24" @click="replyTarget = null">
				<circle cx="12" cy="12" r="10" fill="rgba(255,255,255,0.15)"/>
				<path d="M8.5 8.5l7 7M15.5 8.5l-7 7" stroke="#FFFFFF" stroke-width="1.8" stroke-linecap="round"/>
			</svg>
		</div>
		<!-- 表情选择面板（输入栏上方） -->
		<div class="pl-emoji-panel" v-if="emojiShow">
			<div class="pl-emoji-grid">
				<span class="pl-emoji-item" v-for="(e, ei) in emojiList" :key="ei" @click="pickEmoji(e)">{{ e }}</span>
			</div>
		</div>
		<!-- 输入栏：表情 + 输入框 + 发送 -->
		<div class="pl-input-bar">
			<div class="pl-emoji-btn" @click="toggleEmoji">
				<div class="pl-emoji-face" :class="{ 'pl-emoji-face--active': emojiShow }"></div>
			</div>
			<input class="pl-input" v-model="inputValue" :placeholder="inputPlaceholder" @keydown.enter="submit" />
			<div class="pl-send" :class="{ 'pl-send--loading': submitting }" @click="submit">{{ $t('all.fasong') }}</div>
		</div>
		<!-- 删除确认弹窗 -->
		<div class="pl-confirm" v-if="delTarget">
			<div class="pl-confirm-card">
				<div class="pl-confirm-text">{{ $t('all.shanchupinglun') }}</div>
				<div class="pl-confirm-btns">
					<div class="pl-confirm-btn pl-confirm-btn--cancel" @click="delTarget = null">{{ $t('all.quxiao') }}</div>
					<div class="pl-confirm-btn pl-confirm-btn--ok" @click="confirmDel">{{ $t('all.queding') }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getVideoCommentList, getChildCommentList, commentVideo, replyCommentVideo, deleteComment } from '@/api/user';
import kong from '../kong/kong.vue';
export default {
	name: 'pinglun',
	components: {
		kong
	},
	props: {
		// 视频ID
		videoId: {
			type: [String, Number],
			default: ''
		}
	},
	data() {
		return {
			list: [],
			total: 0,
			page: 1,
			size: 20,
			loading: false,
			loaded: false,
			hasMore: true,
			inputValue: '',
			submitting: false,
			// 回复目标：{ parent: 一级评论, child: 被回复的子评论或 null }
			replyTarget: null,
			// 删除确认目标：{ type: 'comment'|'reply', parent, item, index, childIndex }
			delTarget: null,
			delSubmitting: false,
			// 表情选择面板
			emojiShow: false,
			emojiList: [
				'😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃',
				'😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😚', '😙',
				'😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔',
				'🤐', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '😌', '😔',
				'😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🥵', '🥶',
				'😵', '🤯', '🤠', '🥳', '😎', '🤓', '🥺', '😢', '😭', '😤',
				'😠', '😡', '🤬', '😱', '😨', '😰', '😥', '😓', '😳', '🥺',
				'👍', '👎', '👌', '✌️', '🤞', '🤟', '🤘', '👏', '🙏', '💪',
				'❤️', '💔', '💕', '💖', '🌹', '🎉', '🔥', '💯', '✨', '🎁',
				'🍺', '☕', '🍉', '⚽', '🏀', '🎮', '💰', '🌙', '⭐', '🌈'
			]
		};
	},
	computed: {
		inputPlaceholder() {
			if (this.replyTarget) {
				const name = this.replyTarget.child ? this.replyTarget.child.nickName : this.replyTarget.parent.nickName;
				return this.$t('all.huifu') + ' @' + name;
			}
			return this.$t('all.shuodianshenme');
		},
		replyChipText() {
			if (!this.replyTarget) return '';
			const name = this.replyTarget.child ? this.replyTarget.child.nickName : this.replyTarget.parent.nickName;
			return this.$t('all.huifu') + ' @' + name;
		}
	},
	watch: {
		videoId() {
			this.resetList();
		}
	},
	created() {
		this.resetList();
	},
	beforeDestroy() {
		this.emojiShow = false;
	},
	methods: {
		// ====== 表情 ======
		toggleEmoji() {
			this.emojiShow = !this.emojiShow;
		},
		// 选择表情追加到输入框末尾
		pickEmoji(e) {
			this.inputValue = (this.inputValue || '') + e;
		},
		// ====== 评论列表 ======
		resetList() {
			this.list = [];
			this.total = 0;
			this.page = 1;
			this.hasMore = true;
			this.replyTarget = null;
			this.emojiShow = false;
			if (this.$refs.list) this.$refs.list.scrollTop = 0;
			this.loadList();
		},
		handleListScroll() {
			const el = this.$refs.list;
			if (!el) return;
			if (el.scrollTop + el.clientHeight >= el.scrollHeight - 30) {
				this.loadList();
			}
		},
		loadList() {
			if (this.loading || !this.hasMore || !this.videoId) return;
			this.loading = true;
			getVideoCommentList({
				videoId: this.videoId,
				page: this.page,
				size: this.size
			}).then(response => {
				const rows = (response && response.rows) || [];
				this.total = (response && response.total) || 0;
				this.list = this.list.concat(rows.map(r => this.normalize(r)));
				if (rows.length < this.size) {
					this.hasMore = false;
				}
				this.page++;
			}).catch(e => {
				console.error('获取评论列表失败:', e);
			}).finally(() => {
				this.loading = false;
				this.loaded = true;
			});
		},
		// 子回复按时间倒序（新→旧），最新回复在最上面
		sortChilds(list) {
			return (list || []).sort((a, b) => (b.createTime || '').localeCompare(a.createTime || ''));
		},
		// 字段归一化（按后端真实返回结构）
		normalize(c) {
			const preloaded = c.childList || [];
			return {
				id: c.commentId,
				userId: c.userId,
				avatar: c.userHeadPortrait || '',
				nickName: c.userNickName || '',
				content: c.content || '',
				createTime: c.createTime || '',
				// 是否当前登录用户自己的评论（后端字段）：1=是，只有自己的评论可删除
				isPresentUser: c.isPresentUser,
				// 回复数与预载回复列表
				replyNumber: c.childCount || 0,
				childs: this.sortChilds(preloaded.map(r => this.normalize(r))),
				childPage: 1,
				childHasMore: preloaded.length < (c.childCount || 0),
				childLoading: false
			};
		},
		// 只有自己的评论可以删除（后端 isPresentUser 标记）
		isMine(c) {
			return c.isPresentUser == 1;
		},
		// ====== 子回复 ======
		async loadChilds(c) {
			if (c.childLoading || !c.childHasMore) return;
			c.childLoading = true;
			try {
				const response = await getChildCommentList({
					commentId: c.id,
					page: c.childPage,
					size: this.size
				});
				const rows = (response && response.rows) || [];
				// 去重（列表接口可能已预载部分子回复）
				const existing = {};
				c.childs.forEach(x => { existing[x.id] = true; });
				rows.forEach(r => {
					const n = this.normalize(r);
					if (!existing[n.id]) {
						c.childs.push(n);
						existing[n.id] = true;
					}
				});
				this.sortChilds(c.childs);
				if (rows.length < this.size || c.childs.length >= c.replyNumber) {
					c.childHasMore = false;
				} else {
					c.childPage++;
				}
			} catch (e) {
				console.error('获取回复列表失败:', e);
			} finally {
				c.childLoading = false;
			}
		},
		childMoreText(c) {
			return c.childLoading ? this.$t('all.jiazaizhong') : this.$t('all.jiazaigengduo');
		},
		// ====== 发布评论 / 回复 ======
		startReply(parent, child) {
			this.replyTarget = { parent, child: child || null };
		},
		async submit() {
			const content = (this.inputValue || '').trim();
			if (!content || this.submitting) return;
			this.submitting = true;
			try {
				let response;
				if (this.replyTarget) {
					const parent = this.replyTarget.parent;
					response = await replyCommentVideo({
						videoId: this.videoId,
						commentId: parent.id,
						content
					});
					const created = this.pickCreated(response);
					if (created) {
						// 最新回复插到最前面
						parent.childs.unshift(created);
						parent.replyNumber++;
					} else {
						// 拿不到返回对象时，重新拉取该评论的回复列表
						parent.childs = [];
						parent.childPage = 1;
						parent.childHasMore = true;
						await this.loadChilds(parent);
						parent.replyNumber++;
					}
				} else {
					response = await commentVideo({
						videoId: this.videoId,
						content
					});
					const created = this.pickCreated(response);
					if (created) {
						this.list.unshift(created);
						this.total++;
					} else {
						// 拿不到返回对象时，重新加载第一页
						this.resetList();
					}
					this.$emit('count-change', 1);
				}
				this.inputValue = '';
				this.replyTarget = null;
			} catch (e) {
				console.error('评论失败:', e);
			} finally {
				this.submitting = false;
			}
		},
		// 从接口返回中提取新建的评论对象
		pickCreated(response) {
			const d = response && response.data;
			if (d && typeof d === 'object' && d.content && (d.commentId !== undefined || d.id !== undefined)) {
				return this.normalize(d);
			}
			return null;
		},
		// ====== 删除（面板内确认弹窗） ======
		delComment(c, ci) {
			this.delTarget = { type: 'comment', item: c, index: ci };
		},
		delReply(parent, r, ri) {
			this.delTarget = { type: 'reply', parent, item: r, childIndex: ri };
		},
		async confirmDel() {
			if (!this.delTarget || this.delSubmitting) return;
			this.delSubmitting = true;
			try {
				const t = this.delTarget;
				await deleteComment({ commentId: t.item.id });
				if (t.type === 'comment') {
					this.list.splice(t.index, 1);
					this.total = Math.max(this.total - 1, 0);
					this.$emit('count-change', -1);
				} else {
					t.parent.childs.splice(t.childIndex, 1);
					t.parent.replyNumber = Math.max(t.parent.replyNumber - 1, 0);
				}
				this.delTarget = null;
			} catch (e) {
				console.error('删除评论失败:', e);
			} finally {
				this.delSubmitting = false;
			}
		},
		// ====== 工具 ======
		formatTime(str) {
			if (!str) return '';
			const t = new Date(String(str).replace(/-/g, '/')).getTime();
			if (!t || isNaN(t)) return str;
			const diff = Date.now() - t;
			const min = Math.floor(diff / 60000);
			if (min < 1) return this.$t('all.ganggang');
			if (min < 60) return this.$t('all.fenzhongqian', { n: min });
			const hour = Math.floor(min / 60);
			if (hour < 24) return this.$t('all.xiaoshiqian', { n: hour });
			const day = Math.floor(hour / 24);
			if (day < 7) return this.$t('all.tianqian', { n: day });
			return String(str).slice(0, 10);
		}
	}
};
</script>

<style scoped lang="scss">
	.pl-box{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		position: relative;
		overflow: hidden;
	}
	.pl-list{
		flex: 1;
		height: 0;
		overflow-y: auto;
		padding: 0 16px;
		box-sizing: border-box;
	}
	.pl-list::-webkit-scrollbar{
		display: none;
	}
	.pl-item{
		display: flex;
		margin-top: 16px;
	}
	.pl-avatar{
		width: 36px;
		height: 36px;
		border-radius: 50%;
		flex-shrink: 0;
		object-fit: cover;
	}
	.pl-avatar--empty{
		background: #3A3A3E;
	}
	.pl-main{
		flex: 1;
		margin-left: 10px;
		min-width: 0;
	}
	.pl-name{
		color: #FFFFFF;
		font-size: 14px;
		font-weight: 500;
	}
	.pl-content{
		color: rgba(255,255,255,0.9);
		font-size: 14px;
		margin-top: 4px;
		word-break: break-word;
	}
	.pl-meta{
		display: flex;
		align-items: center;
		margin-top: 6px;
	}
	.pl-time{
		color: rgba(255,255,255,0.4);
		font-size: 12px;
	}
	.pl-reply-btn{
		color: rgba(255,255,255,0.4);
		font-size: 12px;
		margin-left: 24px;
		cursor: pointer;
	}
	.pl-del{
		color: #FF6B6B;
		font-size: 12px;
		margin-left: 24px;
		cursor: pointer;
	}
	.pl-childs{
		margin-top: 10px;
		padding-left: 4px;
	}
	.pl-child{
		display: flex;
		margin-bottom: 12px;
	}
	.pl-child-avatar{
		width: 26px;
		height: 26px;
		border-radius: 50%;
		flex-shrink: 0;
		object-fit: cover;
	}
	.pl-child-more{
		color: #369AFF;
		font-size: 12px;
		padding: 4px 0;
		cursor: pointer;
	}
	.pl-expand{
		color: #369AFF;
		font-size: 12px;
		margin-top: 6px;
		cursor: pointer;
	}
	.pl-tip{
		text-align: center;
		color: rgba(255,255,255,0.4);
		font-size: 12px;
		padding: 12px 0;
	}
	/* 回复目标提示 */
	.pl-reply-chip{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 4px 16px 0;
		padding: 4px 12px;
		background: rgba(54,154,255,0.15);
		border-radius: 12px;
		flex-shrink: 0;
	}
	.pl-reply-chip-text{
		color: #369AFF;
		font-size: 12px;
	}
	.pl-reply-chip-close{
		width: 15px;
		height: 15px;
		cursor: pointer;
	}
	/* 表情选择面板 */
	.pl-emoji-panel{
		flex-shrink: 0;
		height: 200px;
		margin: 4px 16px 0;
		border-top: 1px solid rgba(255,255,255,0.08);
		overflow-y: auto;
		scrollbar-width: none;
		-ms-overflow-style: none;
	}
	.pl-emoji-panel::-webkit-scrollbar{
		display: none;
	}
	.pl-emoji-grid{
		display: flex;
		flex-wrap: wrap;
	}
	.pl-emoji-item{
		width: 20%;
		height: 38px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		line-height: 1;
		cursor: pointer;
	}
	/* 输入栏 */
	.pl-input-bar{
		display: flex;
		align-items: center;
		margin: 8px 16px 12px;
		padding: 0 6px 0 10px;
		height: 40px;
		background: rgba(255,255,255,0.08);
		border-radius: 20px;
		flex-shrink: 0;
	}
	.pl-emoji-btn{
		padding: 4px;
		flex-shrink: 0;
		cursor: pointer;
		display: flex;
		align-items: center;
	}
	.pl-emoji-face{
		position: relative;
		width: 20px;
		height: 20px;
		border: 1.5px solid rgba(255,255,255,0.9);
		border-radius: 50%;
		box-sizing: border-box;
	}
	.pl-emoji-face::before{
		content: '';
		position: absolute;
		top: 5px;
		left: 4.5px;
		width: 2px;
		height: 4px;
		background: rgba(255,255,255,0.9);
		border-radius: 1px;
		box-shadow: 7px 0 0 rgba(255,255,255,0.9);
	}
	.pl-emoji-face::after{
		content: '';
		position: absolute;
		left: 3.5px;
		bottom: 3px;
		width: 10px;
		height: 5px;
		border: 1.5px solid rgba(255,255,255,0.9);
		border-top: none;
		border-left-color: transparent;
		border-right-color: transparent;
		border-radius: 0 0 10px 10px;
		box-sizing: border-box;
	}
	.pl-emoji-face--active{
		border-color: #369AFF;
	}
	.pl-emoji-face--active::before{
		background: #369AFF;
		box-shadow: 7px 0 0 #369AFF;
	}
	.pl-emoji-face--active::after{
		border-bottom-color: #369AFF;
	}
	.pl-input{
		flex: 1;
		height: 100%;
		margin-left: 6px;
		background: transparent;
		border: none;
		outline: none;
		color: #FFFFFF;
		font-size: 13px;
	}
	.pl-input::placeholder{
		color: rgba(255,255,255,0.35);
		font-size: 13px;
	}
	.pl-send{
		margin-left: 10px;
		padding: 0 18px;
		height: 28px;
		line-height: 28px;
		text-align: center;
		background: #369AFF;
		border-radius: 14px;
		color: #FFFFFF;
		font-size: 12px;
		flex-shrink: 0;
		cursor: pointer;
	}
	.pl-send--loading{
		opacity: 0.6;
	}
	/* 删除确认弹窗 */
	.pl-confirm{
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background: rgba(0,0,0,0.6);
		z-index: 10080;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.pl-confirm-card{
		width: 320px;
		background: #22222A;
		border-radius: 12px;
		padding: 28px 20px 20px;
		box-sizing: border-box;
	}
	.pl-confirm-text{
		text-align: center;
		color: #FFFFFF;
		font-size: 15px;
	}
	.pl-confirm-btns{
		display: flex;
		margin-top: 24px;
	}
	.pl-confirm-btn{
		flex: 1;
		height: 34px;
		line-height: 34px;
		text-align: center;
		border-radius: 17px;
		font-size: 13px;
		cursor: pointer;
	}
	.pl-confirm-btn--cancel{
		background: rgba(255,255,255,0.12);
		color: rgba(255,255,255,0.7);
		margin-right: 12px;
	}
	.pl-confirm-btn--ok{
		background: #369AFF;
		color: #FFFFFF;
	}
</style>



// WEBPACK FOOTER //
// pinglun.vue?09b936ae